import React from 'react'
import { createComponent } from '@ycos/fela'
import LoyaltyMarkdown from './LoyaltyMarkdown'

const LoyaltySubtextBox = createComponent(
  'LoyaltySubtextBox',
  ({ theme }) => {
    const rtlFontStyle = theme.custom.loyaltySubtext || {};

    return ({
      textAlign: 'center',
      ...rtlFontStyle
    })
  },
  'div'
)

const LoyaltySubtext = ({ item }) => {
  const { teaserText } = item
  return (
    <LoyaltySubtextBox>
      <LoyaltyMarkdown teaserText={teaserText} />
    </LoyaltySubtextBox>
  )
}

LoyaltySubtext.layoutVariant = 'isc-loyalty-subtext'

export default LoyaltySubtext
